var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.362 16H2.17971C0.979066 16 0 15.0209 0 13.8203V3.638C0 2.43221 0.979066 1.45314 2.17971 1.45314H7.99742C8.39936 1.45314 8.72399 1.77778 8.72399 2.17971C8.72399 2.58164 8.39936 2.90628 7.99742 2.90628H2.17971C1.77778 2.90628 1.45314 3.23092 1.45314 3.63285V13.8151C1.45314 14.2171 1.77778 14.5417 2.17971 14.5417H12.362C12.7639 14.5417 13.0886 14.2171 13.0886 13.8151V7.99742C13.0886 7.59549 13.4132 7.27085 13.8151 7.27085C14.2171 7.27085 14.5417 7.59549 14.5417 7.99742V13.8151C14.5417 15.0158 13.5626 15.9948 12.362 15.9948V16Z",
    fill: "#1C1C1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2734 0H10.9088C10.6151 0 10.3471 0.175201 10.2389 0.448309C10.1307 0.721417 10.1874 1.0306 10.3986 1.24187L12.0682 2.91143L6.76578 8.21385C6.48237 8.49726 6.48237 8.95588 6.76578 9.24445C6.91007 9.38873 7.09557 9.45572 7.28108 9.45572C7.46659 9.45572 7.6521 9.38358 7.79638 9.24445L13.0988 3.94203L14.7684 5.61159C14.9075 5.75073 15.093 5.82287 15.2837 5.82287C15.3764 5.82287 15.4743 5.80741 15.5619 5.76618C15.835 5.65282 16.0102 5.39002 16.0102 5.0963V0.72657C15.9999 0.324638 15.6753 0 15.2734 0Z",
    fill: "#1C1C1C"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkFill);
export default __webpack_public_path__ + "static/media/link-fill.4ed46137245de5564b74f2d598e01618.svg";
export { ForwardRef as ReactComponent };